function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#AEFF00;}\n\t.st1{fill:none;}\n\t.st2{fill:#16161A;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M52.4,3.6c-1.9,0-3.6,0.6-5.1,1.6V0H13.7v5.2c-1.4-1-3.2-1.6-5.1-1.6C3.9,3.6,0,7.4,0,12.2v0.6 c0,4.8,3.9,8.6,8.6,8.6h5.1v3.3c0,9.3,7.5,16.8,16.8,16.8S47.3,34,47.3,24.8v-3.3h5.1c4.8,0,8.6-3.9,8.6-8.6v-0.6 C61,7.4,57.1,3.6,52.4,3.6z M13.7,17.9H8.6c-2.8,0-5.1-2.3-5.1-5.1v-0.6c0-2.8,2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1V17.9z M37.2,28.6 h-4.9v3.6h-3.6v-3.6h-4.6v10.1h4.6v-3.6h3.6v3.6h2.5v-0.9h2.4V28.6z M57.4,12.8c0,2.8-2.3,5.1-5.1,5.1h-5.1v-5.7 c0-2.8,2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1V12.8z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M37.2,50.3h-0.7v-6c-1.9,0.6-3.9,0.9-6,0.9s-4.1-0.3-6-0.9v6h-0.7c-3.9,0-7,3.2-7,7V61h27.4v-3.7 C44.2,53.4,41,50.3,37.2,50.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 8,
  className: "st1",
  width: 18,
  height: 25
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M37.8,14.7c-0.1-1-0.3-1.8-0.7-2.7c-1.2-2.3-2.9-3.7-5.2-4c-1.3-0.2-2.6,0-3.8,0.6c-1.9,1-3.2,2.6-3.7,4.9 c-0.1,0.4-0.2,0.8-0.2,1.3c0,0-0.1,0-0.1,0c-0.4-0.2-0.8-0.2-1.2-0.1c-0.5,0.1-0.9,0.6-0.8,1.1c0,0.3,0.1,0.6,0.2,0.9 c0.1,0.2,0.2,0.4,0.3,0.6c0.4,0.7,0.8,1.3,1.2,2c0.2,0.3,0.3,0.5,0.3,0.9c0,0.6,0,1.2-0.1,1.7c-0.1,0.8,0,1.6,0.1,2.4 c0.1,0.9,0.5,1.7,0.8,2.5c0,0,0,0.1,0,0.1c0.1,0.1,0.1,0.1,0.2,0c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.3-0.2,0.4,0 c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.3,0.2,0.6,0.3,1c0.1,0.2,0.2,0.4,0.3,0.7c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.1,0.6,0.1 c0.1,0.1,0.1,0.3,0.2,0.4c0.2,0.5,0.4,1,0.6,1.4c0.1,0.3,0.3,0.6,0.5,0.9l0.1,0c0-0.1,0-0.2,0-0.2c0.1-0.3,0.1-0.5,0.2-0.8 c0.2-0.5,0.7-0.6,1.1-0.2c0.2,0.2,0.3,0.5,0.4,0.8c0.3,0.6,0.4,1.3,0.5,2c0,0.1,0,0.2,0.1,0.3l0.1,0c0-0.1,0.1-0.2,0.1-0.3 c0.2-0.5,0.5-1.1,0.7-1.6c0.1-0.3,0.4-0.4,0.7-0.4c0.1,0,0.2,0.1,0.3,0.1c0.1-0.6,0.5-1.1,0.8-1.5c0.3-0.3,0.5-0.3,0.7,0.1 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.1,0.1,0.2c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.3,0.2-0.7,0.3-1c0.1-0.6,0.3-1.1,0.6-1.6 c0.1-0.2,0.4-0.3,0.6,0c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.3,0.2,0.5c0,0,0-0.1,0.1-0.1c0.6-1.1,1-2.3,1-3.6c0-1,0-2.1,0-3.1 c0-0.6,0.1-1.1,0.4-1.5c0.5-0.7,0.9-1.4,1.3-2.1c0.2-0.3,0.3-0.6,0.3-0.9c0.1-0.6,0-1-0.5-1.2c-0.2-0.1-0.4-0.1-0.6-0.1 C38.5,14.7,38.2,14.7,37.8,14.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M33.8,15.9c0.9,0,1.4-0.7,1.3-1.7c-0.1-0.3-0.2-0.4-0.5-0.4c-0.4,0.2-0.8,0.3-1.2,0.5c-0.1,0-0.2,0.1-0.2,0.2 c-0.2,0.3-0.2,0.6-0.1,0.9c0.1,0.3,0.3,0.3,0.5,0.3C33.7,15.9,33.8,15.9,33.8,15.9z M28.1,15.9c0.1,0,0.2,0,0.3,0 c0.2,0,0.3-0.1,0.4-0.4c0.1-0.5,0-0.9-0.4-1.1c-0.4-0.2-0.7-0.4-1.1-0.5c-0.3-0.1-0.4,0.1-0.5,0.4C26.7,15.2,27.2,15.9,28.1,15.9 L28.1,15.9z"
});

function SvgGhostrewardVeteranlogoGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61 61",
    style: {
      enableBackground: "new 0 0 61 61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostrewardVeteranlogoGreen);
export default __webpack_public_path__ + "static/media/ghostrewardVeteranlogo-green.1dda935e860a4d8ae776cbb3e4bd9933.svg";
export { ForwardRef as ReactComponent };